// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const EXPERIMENT_OPTIMIZATION_TRAINING_STEP_SHAPES = [
  {
    stepType: PipelineStepType.EXPERIMENT_OPTIMIZATION_TRAINING,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Training dataset': {
        systemName: 'Training dataset',
        displayName: 'Training dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Model file': {
        systemName: 'Model file',
        displayName: 'Model file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      },
      'Model performance': {
        systemName: 'Model performance',
        displayName: 'Model performance',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Model predictions': {
        systemName: 'Model predictions',
        displayName: 'Model predictions',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Model comparison': {
        systemName: 'Model comparison',
        displayName: 'Model comparison',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Categorical design space': {
        systemName: 'Categorical design space',
        displayName: 'Categorical design space',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Continuous design space': {
        systemName: 'Continuous design space',
        displayName: 'Continuous design space',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      targetColumn: {
        kind: 'columnReference',
        required: true,
        inputDataName: 'Input dataset',
        allowMissingColumn: false,
        validationOptions: {
          allowedLeafTypes: [
            LeafType.INTEGER,
            LeafType.DECIMAL
          ]
        }
      },
      groupingColumn: {
        kind: 'columnReference',
        required: false,
        inputDataName: 'Input dataset',
        allowMissingColumn: false,
        validationOptions: null
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
